import React, { useState, useContext } from "react";
import logo from "./logo.png";
import { Stack, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { httpService } from "../httpService";
import { AlertContext } from "../contexts/AlertContext";
import { Badge } from "react-bootstrap";
import Webcam from "react-webcam";
import { QrReader } from "react-qr-reader";
import { CircularProgress } from "@mui/material";
import { DoneAll, QrCode } from "@mui/icons-material";

export default function ManageRegistration() {
  const [institutionId, setInstitutionId] = useState("");
  const [participants, setParticipants] = useState([]);

  const { setAlertData } = useContext(AlertContext);
  const [loading, setLoading] = useState(false);
  const [scanning, setScanning] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [marking, setMarking] = useState(false);

  const [result, setResult] = useState("");

  const getData = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { data, error } = await httpService.post("viewparticipants", {
      institutionId,
    });
    if (data) {
      //console.log(data);
      setParticipants(data);
    }
    if (error) {
      setParticipants([]);
      setAlertData({ open: true, message: error, severity: "error" });
    }
    setLoading(false);
  };

  const refreshData = async () => {
    setLoading(true);
    const { data, error } = await httpService.post("viewparticipants", {
      institutionId,
    });
    if (data) {
      //console.log(data);
      setParticipants(data);
    }
    if (error) {
      setParticipants([]);
      setAlertData({ open: true, message: error, severity: "error" });
    }
    setLoading(false);
  };

  // const deleteRegistration = async (id) => {
  //   setDeleting(true);
  //   const { data, error } = await httpService.delete(
  //     `delete/${id}`
  //   );
  //   if (data) {
  //     setParticipants(participants.filter((p) => p._id !== id));
  //     setAlertData({ open: true, message: data, severity: "success" });
  //   }

  //   if (error) {
  //     setAlertData({ open: true, message: error, severity: "error" });
  //   }
  //   setDeleting(false);
  // };

  const markAttendance = async (attendee) => {
    setMarking(true);
    const { data, error } = await httpService.post("markattendance", {
      attendee,
    });

    if (data) {
      refreshData();
      setAlertData({
        open: true,
        message: data,
        severity: "success",
      });
    }
    if (error) {
      setAlertData({
        open: true,
        message: error,
        severity: "error",
      });
    }
    setMarking(false);
  };
  return (
    <div>
      <div className="mb-5  manage ">
        <div className="container">
          <div className="p-3 text-white  text-center ">
            <div>
              <img src={logo} height={100} width={120} alt="Jamb Logo" />
            </div>
            <div>
              <Typography variant="h4" fontWeight={700}>
                Jamb Policy Meeting {new Date().getFullYear()}
              </Typography>
              <Typography>Attendance Manager</Typography>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 container">
        <div className="">
          <div className="col-lg-4">
            <form onSubmit={getData}>
              <div className="mb-3">
                <TextField
                  fullWidth
                  label="Institution Id"
                  onChange={(e) => setInstitutionId(e.target.value)}
                />
              </div>
              <div className="">
                <Stack direction={"row"} spacing={2}>
                  <LoadingButton
                    type="submit"
                    loading={loading}
                    variant="contained"
                  >
                    Get Participants
                  </LoadingButton>
                  <Typography>OR</Typography>
                  <LoadingButton
                    loading={updating}
                    color="error"
                    variant="contained"
                    endIcon={<QrCode />}
                    onClick={() => setScanning(!scanning)}
                  >
                    Scan QR Code
                  </LoadingButton>
                </Stack>
              </div>
            </form>
            {result && (
              <Typography gutterBottom color={"red"} fontWeight={700}>
                {result}
              </Typography>
            )}
            {scanning && (
              <QrReader
                scanDelay={3000}
                onResult={async (result, error) => {
                  if (error) {
                    setResult("Can't find QR Code");
                  }
                  if (result) {
                    setResult("");
                    setScanning(false);
                    setUpdating(true);
                    const attendee = result.getText().split("/").pop();
                    markAttendance(attendee);

                    setUpdating(false);
                  }
                }}
                constraints={{ facingMode: "environment" }}
              />
            )}

            {updating && <CircularProgress className="mt-2" />}
          </div>
          {/* <WebCamComponent /> */}
        </div>
        <div className=" mt-3">
          {participants[0] && (
            <div className="alert alert-success">
              <Typography variant="caption">Institution</Typography>
              <Typography variant="h6">
                {participants[0].institution}
              </Typography>
            </div>
          )}
          {participants.map((c, i) => (
            <div key={i} className="alert alert-light">
              <div className="row d-flex align-items-center">
                <div className="col-lg-4">
                  <img
                    className="img-thumbnail"
                    src={c.imageURL}
                    alt={c.firstName}
                  />
                </div>
                <div className="col-lg-5">
                  <Typography gutterBottom>
                    {c.title} {c.firstName} {c.lastName}
                  </Typography>
                  <Typography gutterBottom>{c.role}</Typography>
                  <Typography gutterBottom>{c.code}</Typography>

                  {c.status === "complete" && (
                    <Badge bg="success">{c.status}</Badge>
                  )}
                  {c.status === "incomplete" && (
                    <Badge bg="warning">{c.status}</Badge>
                  )}
                </div>
                <div className="col-lg-3">
                  <div className="d-none d-lg-block">
                    {c.attendanceMarked ? (
                      <div
                        className="p-3 rounded-3 shadow-sm"
                        style={{ backgroundColor: "#0A032A", color: "white" }}
                      >
                        <Typography>
                          ATTENDANCE MARKED <DoneAll className="ms-3" />
                        </Typography>
                      </div>
                    ) : (
                      <LoadingButton
                        color="success"
                        variant="contained"
                        onClick={() => markAttendance(c._id)}
                        className="mb-2"
                        loading={marking}
                      >
                        Mark Attendance
                      </LoadingButton>
                    )}
                  </div>
                  <div className="d-sm-block d-lg-none">
                    <div className="mt-3">
                      {c.attendanceMarked ? (
                        <div
                          className="p-3 rounded-3 shadow-sm"
                          style={{ backgroundColor: "#0A032A", color: "white" }}
                        >
                          <Typography>
                            ATTENDANCE MARKED <DoneAll className="ms-3" />
                          </Typography>
                        </div>
                      ) : (
                        <LoadingButton
                          color="success"
                          variant="contained"
                          onClick={() => markAttendance(c._id)}
                          className="mb-2"
                          loading={marking}
                        >
                          Mark Attendance
                        </LoadingButton>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const WebCamComponent = () => <Webcam />;
